<ng-template #addressRows>
  <!--
    a11y: each icon visually marks the address role (origin / waypoint /
    destination). SR users get that role via role="img" + aria-label so the
    summary reads e.g. "Origin point, Spinoza/Palmach 35143".
  -->
  <span class="flex gap-2 items-center text-base">
    <ng-icon
      class="text-primary-gold text-2xl"
      name="circle-dot"
      role="img"
      [attr.aria-label]="originPointLabel" />
    <span class="!text-base">{{ origin }}</span>
  </span>

  @if (leg) {
    <span class="flex gap-2 items-center text-base">
      <ng-icon
        class="text-primary-gold text-2xl"
        name="circle-empty"
        role="img"
        [attr.aria-label]="waypointLabel" />
      <span class="!text-base">{{ leg }}</span>
    </span>
  }

  @if (stop) {
    <span class="flex gap-2 items-center text-base">
      <ng-icon
        class="text-primary-gold text-2xl"
        name="circle-empty"
        role="img"
        [attr.aria-label]="waypointLabel" />
      <span class="!text-base">{{ stop }}</span>
    </span>
  }

  <span class="flex gap-2 items-center text-base">
    <ng-icon
      class="text-primary-gold text-2xl"
      name="location-dot"
      role="img"
      [attr.aria-label]="destinationPointLabel" />
    <span class="!text-base">{{ destination }}</span>
  </span>
</ng-template>

@if (asRouteSummaryHeading) {
  <h2
    class="addresses-details__route-heading flex flex-wrap cursor-pointer gap-1 m-0 font-normal text-base"
    >
    <ng-container *ngTemplateOutlet="addressRows"></ng-container>
  </h2>
}
@if (!asRouteSummaryHeading) {
  <div class="flex flex-col cursor-pointer gap-1">
    <ng-container *ngTemplateOutlet="addressRows"></ng-container>
  </div>
}
